<template>
    <div class="i-lang-input">
        <label>{{label}}</label>
        <tabs size="xs">
            <tab :title="lang.toUpperCase()" :icon='data[lang]?"check-circle":"times-circle"' :key="i" v-for="(lang,i) in langs" :padding="0">
                <inputi v-if="type==='string'" v-model="data[lang]" class="input-mini" @input="change" :placeholder="placeholder" />
                <text-box :cols="cols" :rows="rows" v-if="type==='text'"  v-model="data[lang]" class="input-mini" @input="change" :placeholder="placeholder" />
                <i-wysiwyg v-if="type==='wysiwyg'" :label="label" v-model="data[lang]" @input="change" :placeholder="placeholder" />
            </tab>
        </tabs>
    </div>
</template>
<script>
import iWysiwyg from "./i-wysiwyg2.vue";
export default {
    components: { iWysiwyg },
    props: {
        "value": { type: Object, default () { return {} } },
        "label": { type: String, default: '' },
        "cols": { type: Number ,default: 5},
        "rows": { type: Number , default: 10},
        "type": { type: String, default: 'string' },
        "placeholder": { type: String, default: '' }
    },
    name: 'i-lang-input',
    methods: {
        change() {
            this.$emit('input', this.data);
        }
    },
    mounted() {
        if (!this.langs) {
            alert("SET LANGS ON ROOT PLEASE");
        }
        if (typeof this.value != "object") {
            this.data = {};
        } else {
            this.data = this.value;
        }
    },
    data() {
        return {
            data: {},
            colors: ["#7ED321", "#FF4D4D", "#4A90E2", "#9013FE", "#FFF46A"]
        }
    }
}
</script>
<style lang="css" scoped>
label {
    font-weight: bold;
    margin-bottom: 4px;
    display: block;
}

.i-lang-input {
    margin-bottom: 12px;
}

.i-langency {
    display: inline-block;
}

table {
    border-collapse: collapse;
}

.input-mini {
    padding: 0;
    margin: 0;
    margin-top: -1px;
}
</style>
<style lang="css">
.i-lang-input .inputi {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
</style>